import request from '@/utils/request'

export function findBaseModuleProducts(params) {
  return request({
    url: `/base_module_products`,
    method: 'get',
    params
  })
}

export function findImportableBaseModuleProducts(params) {
  return request({
    url: `/base_module_products/importable`,
    method: 'get',
    params
  })
}

export function createBaseModuleProduct(data) {
  return request({
    url: `/base_module_products`,
    method: 'post',
    data
  })
}

export function findBaseModuleProductForm(id) {
  return request({
    url: `/base_module_products/${id}/form`,
    method: 'get'
  })
}

export function updateBaseModuleProduct(id, data) {
  return request({
    url: `/base_module_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateBaseModuleProductsEffective(ids, effective) {
  return request({
    url: `/base_module_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
